// The contact modal is mounted globally in MainLayout as a sibling of every
// page, so a page can't reach it via props. A window CustomEvent lets any
// page ask the modal to prefill itself right before it opens.
export const CONTACT_PREFILL_EVENT = 'contactModal:prefill';

export const requestContactPrefill = (detail) => {
  window.dispatchEvent(new CustomEvent(CONTACT_PREFILL_EVENT, { detail }));
};
